export default __webpack_public_path__ + "static/media/camdigikey-no-bg.54302513.png";